import api from '../../api/api';
import { AUTH_STATUS } from "@/utils/constants";

const state = {
    authStatus: AUTH_STATUS.UNKNOWN,
};

const getters = {
    shouldShowLogin: state => state.authStatus === AUTH_STATUS.UNAUTHENTICATED,
    noAccess: state => state.authStatus === AUTH_STATUS.FORBIDDEN,
    hasAccess: state => state.authStatus === AUTH_STATUS.AUTHORIZED,
    error: state => state.authStatus === AUTH_STATUS.ERROR,
    shouldShowLogoutButton: state => [AUTH_STATUS.FORBIDDEN, AUTH_STATUS.AUTHORIZED, AUTH_STATUS.ERROR].includes(state.authStatus)
};

const mutations = {
    SET_STATUS(state, status) {
        state.authStatus = status;
    }
};

const actions = {
    async oauth({ commit, dispatch }, params) {
        try {
            await api.authorization.oauth(params);
            await dispatch("checkAuth");
        } catch (error) {
            return Promise.reject(error.response.data.message);
        }
    },
    async checkAuth({ commit }) {
        try {
            await api.authorization.checkAuth();
            commit('SET_STATUS', AUTH_STATUS.AUTHORIZED);
        } catch(error) {
            const status = error.response?.status;
            switch (status) {
                case 401:
                    commit('SET_STATUS', AUTH_STATUS.UNAUTHENTICATED);
                    break;
                case 403:
                    commit('SET_STATUS', AUTH_STATUS.FORBIDDEN);
                    break;
                default:
                    commit('SET_STATUS', AUTH_STATUS.ERROR);
                    break;
            }
        }
    },
    async logout({ commit }) {
        try {
            await api.authorization.logout();
        } finally {
            commit('SET_STATUS', AUTH_STATUS.UNAUTHENTICATED);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
